export const ERROR_STATUS = {
  FATAL_ERROR: 'fatal',
  GEO_ERROR: 'geo',
  DRM_ERROR: 'drm',
  VIDEO_UNAVAILABLE_ERROR: 'videoUnavailable',
  HTTP404_ERROR: 404,
  HTTP408_ERROR: 408,
  HTTP100_ERROR: 100,
  NO_SEE_ALL_CONTENT: 'NoSeeAllContent',
  DEFAULT: 'default',
  LOCALIZATION_ERROR: 'localizationError',
  UNAVAILABLE_STATION: 'unavailableStationError',
} as const

export type ErrorStatus = (typeof ERROR_STATUS)[keyof typeof ERROR_STATUS]
